function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Arrow_table_svg__cls-2{fill:#21374d;opacity:.15;isolation:isolate}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Arrow_table_svg__Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Arrow_table_svg__Warstwa_1-2",
  "data-name": "Warstwa 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Arrow_table_svg__Arrow",
  d: "M1.88 23.46L8 29l6.12-5.56L16 25.17l-8 7.29-8-7.29z",
  fill: "#deb535"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Arrow_table_svg__Shape",
  className: "Arrow_table_svg__cls-2",
  cx: 8,
  cy: 15.25,
  r: 2.75
}), /*#__PURE__*/React.createElement("circle", {
  id: "Arrow_table_svg__Shape-2",
  "data-name": "Shape",
  className: "Arrow_table_svg__cls-2",
  cx: 8,
  cy: 2.75,
  r: 2.75
})));

function SvgArrowtable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 32.46"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAzMi40NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkZWI1MzU7fS5jbHMtMntmaWxsOiMyMTM3NGQ7b3BhY2l0eTowLjE1O2lzb2xhdGlvbjppc29sYXRlO308L3N0eWxlPjwvZGVmcz48dGl0bGU+WmFzw7NiIDE8L3RpdGxlPjxnIGlkPSJXYXJzdHdhXzIiIGRhdGEtbmFtZT0iV2Fyc3R3YSAyIj48ZyBpZD0iV2Fyc3R3YV8xLTIiIGRhdGEtbmFtZT0iV2Fyc3R3YSAxIj48cGF0aCBpZD0iQXJyb3ciIGNsYXNzPSJjbHMtMSIgZD0iTTEuODgsMjMuNDYsOCwyOWw2LjEyLTUuNTZMMTYsMjUuMTcsOCwzMi40NiwwLDI1LjE3WiIvPjxjaXJjbGUgaWQ9IlNoYXBlIiBjbGFzcz0iY2xzLTIiIGN4PSI4IiBjeT0iMTUuMjUiIHI9IjIuNzUiLz48Y2lyY2xlIGlkPSJTaGFwZS0yIiBkYXRhLW5hbWU9IlNoYXBlIiBjbGFzcz0iY2xzLTIiIGN4PSI4IiBjeT0iMi43NSIgcj0iMi43NSIvPjwvZz48L2c+PC9zdmc+";
export { SvgArrowtable as ReactComponent };